export const GET_NEXT_RELEASES = 'blogs/nextReleases/get';
export const GET_NEXT_RELEASE_BY_ID = 'blogs/nextReleaseById/get';
export const GET_NEXT_RELEASE_BY_SLUG = 'blogs/nextReleaseBySlug/get';